import { MESSAGE_TYPES } from '../../../constants/chat';

const getFakeUploadAttachmentMessage = (channelId, name) => {
  const now = new Date().toISOString();
  const insertedAt = now.substr(0, now.indexOf('Z'));

  return {
    id: Math.random(),
    type: MESSAGE_TYPES.UPLOAD_ATTACHMENT,
    chatRoomUid: channelId,
    insertedAt,
    body: null,
    authorId: null,
    meta: {},
    payload: {
      name,
    },
  };
};

export default getFakeUploadAttachmentMessage;



// WEBPACK FOOTER //
// ./src/redux/chatConnection/helpers/getFakeUploadAttachmentMessage.js